module.exports = __webpack_public_path__ + "img/29.f70eb915.jpg";